import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Select } from 'next/components/ui';
import CoolTip from 'components/Common/CoolTip';
import { NORMALIZED_PLAN_LIMIT, PLAN_LIMITS } from 'constants/plans';
import { numberWithCommas } from 'utils/textFormatting';

export const selectOptions = PLAN_LIMITS.map(bracket => ({
  label: bracket.name,
  value: bracket.id,
}));

const ControlsWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const PlanSelectSection = styled.div`
  width: 50%;
`;

const PlanSelectHeader = styled.div`
  display: flex;

  label.header {
    color: #1e1e1e;
  }

  .mau-hint {
    color: ${props => props.theme['$gray-30']};
    margin-left: 8px;
  }
`;

const SelectWrapper = styled.div`
  margin: 16px 0;
  width: 75%;
`;

const MonthlyUsersCount = styled.span`
  font-size: 14px;
`;

export default function Controls({ allTimeStats, onChangeLimit, planLimit }) {
  const { monthlyWebsiteUsers } = allTimeStats;
  const displayUserCount = monthlyWebsiteUsers
    ? numberWithCommas(monthlyWebsiteUsers)
    : 'None yet';

  const normalizedLimit =
    planLimit > NORMALIZED_PLAN_LIMIT ? 'high-volume' : `${planLimit}`;

  const selected = selectOptions.find(({ value }) => value === normalizedLimit);

  return (
    <ControlsWrapper>
      <PlanSelectSection>
        <PlanSelectHeader>
          <label className="header">
            How many monthly active users (MAUs) do you have?
          </label>
          <CoolTip
            className="mau-hint"
            tip="# of unique users that log into your platform each month"
          />
        </PlanSelectHeader>
        <SelectWrapper>
          <Select
            value={selected}
            options={selectOptions}
            onChange={onChangeLimit}
          />
        </SelectWrapper>
        <MonthlyUsersCount overLimit={monthlyWebsiteUsers > planLimit}>
          Current MAU Count: {displayUserCount}
        </MonthlyUsersCount>
      </PlanSelectSection>
    </ControlsWrapper>
  );
}

Controls.propTypes = {
  allTimeStats: PropTypes.shape({
    monthlyWebsiteUsers: PropTypes.number,
  }),
  onChangeLimit: PropTypes.func,
  planLimit: PropTypes.number,
};
